import * as production from "./production";
export const { API_URL, GD_CLIENT_URL, GD_URL, MIXPANEL_TOKEN, isLocal } =
  production;
